import type { PaginationLocale } from 'rsuite/esm/locales';

export const PAGINATION_LOCALE: PaginationLocale = {
  more: 'Більше',
  prev: 'Попередня',
  next: 'Наступна',
  first: 'Перша',
  last: 'Остання',
  limit: '{0} / стор.',
  total: 'Показано: {0}',
  skip: 'Перейти до сторінки {0}',
};

export const renderPaginationTotal = (
  total: number,
  activePage: number,
  limit: number
) => {
  const safePage = activePage > 0 ? activePage : 1;
  const safeLimit = limit > 0 ? limit : 1;
  const start = total === 0 ? 0 : (safePage - 1) * safeLimit + 1;
  const end = total === 0 ? 0 : Math.min(total, safePage * safeLimit);

  return `Показано ${start}-${end} з ${total}`;
};
